import { Box, HStack } from '@chakra-ui/react';
import { useWatch } from 'react-hook-form';

import { SimpleInput } from '../SimpleInput';

type Props = {
  name: string;
  label: string;
  helper?: string;
};

/**
 * There is no colour picker in this repo and one is not worth a dependency, so the value is typed
 * as CSS and the swatch is a Box painted with whatever was typed. A value the browser rejects
 * paints nothing, which is the feedback — the schema deliberately does not parse colours, because
 * the browser is the authority on what is valid in a custom property.
 */
export const ThemeColorInput = ({ name, label, helper }: Props) => {
  const value = useWatch({ name });
  const hasValue = typeof value === 'string' && value.trim().length > 0;
  const swatchColor = hasValue ? value : 'transparent';
  const swatchTitle = hasValue ? value : 'No override';

  return (
    <HStack align="flex-start" spacing="2">
      <Box flex="1" minW="0">
        <SimpleInput name={name} label={label} helper={helper} placeholder="inherit" />
      </Box>
      <Box
        mt="6"
        w="8"
        h="8"
        flexShrink="0"
        borderRadius="md"
        borderWidth="1px"
        borderColor="blackAlpha.400"
        bg={swatchColor}
        title={swatchTitle}
      />
    </HStack>
  );
};
